import React, { useLayoutEffect, useRef, useState } from 'react'
import { Pagination } from './Pagination'
import nodata from "../Utils/assets/img/leads_no_data_found_removebg.png"
import { Table } from 'react-bootstrap'
import { ListSkeleton } from '../Pages/Contacts/contactSkeleton/ListSkeleton'
import { MultiItemChangeBar } from './MultiItemChangeBar'

export const TableWrapper = ({
    hasData,
    tableHeader,
    tableBody,
    displayStartItem,
    displayEndItem,
    totalItems,
    offset,
    setOffset,
    limit,
    setLimit,
    handlePageChange,
    effectivePageCount,
    columnLabels,
    isLoading,
    currPageItems,
    showMultiItemChangeBar,
    setShowMultiItemChangeBar,
    onClickBulkUpdate,
    onDelete,
    onExport,
    onWhatsapp,
    onEmail,
    setSelectedItems,
    module_name
}) => {

    const tableContainerRef = useRef(null)
    const [isOverflowing, setIsOverflowing] = useState(false)

    useLayoutEffect(() => {
        const el = tableContainerRef.current
        if (!el) return

        const checkOverflow = () => {
            setIsOverflowing(el.scrollHeight > el.clientHeight)
        }

        checkOverflow()
        window.addEventListener('resize', checkOverflow)

        return () => window.removeEventListener('resize', checkOverflow)
    }, [limit, currPageItems, effectivePageCount])

    return (
        <div
            ref={tableContainerRef}
            className="listStyleForContact "
            style={{
                flex: 1,
                overflow: "auto",
                maxHeight: "100%",
                scrollbarWidth: "thin",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.scrollbarColor = "#e0e0e0 white"
            }}
        >
            <div
                className=''
                style={{
                    position: "sticky",
                    top: 0,
                    left: 0,
                    right: 0,
                    overflowX: 'hidden',
                    zIndex: 9999
                }}
            >
                <MultiItemChangeBar
                    show={showMultiItemChangeBar}
                    setShow={setShowMultiItemChangeBar}
                    onClickBulkUpdate={onClickBulkUpdate}
                    onDelete={onDelete}
                    onExport={onExport}
                    onWhatsapp={onWhatsapp}
                    onEmail={onEmail}
                    setSelectedItems={setSelectedItems}
                    module_name={module_name}
                />
            </div>
            <Table
                style={{
                    width: "100%",
                    height: "auto",
                    tableLayout: "auto",
                    marginBottom: "0px",
                    borderCollapse: "separate",
                    borderSpacing: "0px",
                    borderRadius: "7px"
                }}
            >
                {
                    isLoading ?
                        <ListSkeleton columnLength={columnLabels?.length} tableHeader={tableHeader} />
                        :
                        <>
                            {tableHeader}
                            <tbody className="position-relative" style={{ textAlign: "start" }}>
                                {
                                    hasData ? (
                                        tableBody
                                    ) : (
                                        <td
                                            colSpan="14"
                                            style={{ textAlign: "center", color: "gray" }}
                                        >
                                            <div
                                                className="d-flex justify-content-center align-items-center"
                                                style={{ position: "absolute", left: " 42%" }}
                                            >
                                                <img
                                                    src={nodata}
                                                    alt=""
                                                    style={{ width: "17rem", marginTop: "0" }}
                                                />
                                            </div>
                                        </td>
                                    )}
                                {isOverflowing && effectivePageCount > 0 && (
                                    <tr className='no-hover-row'>
                                        <td colSpan={columnLabels.length + 2}>
                                            <div className="p-0">
                                                <PaginationContent
                                                    displayStartItem={displayStartItem}
                                                    displayEndItem={displayEndItem}
                                                    totalItems={totalItems}
                                                    offset={offset}
                                                    setOffset={setOffset}
                                                    setLimit={setLimit}
                                                    handlePageChange={handlePageChange}
                                                    effectivePageCount={effectivePageCount}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </>
                }
            </Table>
            {!isOverflowing && effectivePageCount > 0 && (
                <div
                    className='px-2'
                    style={{
                        borderTop: "1px solid #e0e0e0",
                        width: "100%",
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        overflowX: 'hidden',
                        zIndex: 99
                    }}
                >
                    <PaginationContent
                        displayStartItem={displayStartItem}
                        displayEndItem={displayEndItem}
                        totalItems={totalItems}
                        offset={offset}
                        setOffset={setOffset}
                        setLimit={setLimit}
                        handlePageChange={handlePageChange}
                        effectivePageCount={effectivePageCount}
                    />
                </div>
            )}
        </div>

    )
}


export const PaginationContent = ({
    displayStartItem,
    displayEndItem,
    totalItems,
    offset,
    setOffset,
    setLimit,
    handlePageChange,
    effectivePageCount
}) => {
    return <>
        <div
            className="d-flex justify-content-between align-items-center gap-2 mt-0 "
            style={{ padding: "0.7rem 0", borderRadius: '7px', background: 'white' }}
        >
            <div className="pagination-left">
                <p
                    className="mb-0"
                    style={{
                        fontSize: "14px",
                        paddingRight: "7rem",
                    }}
                >
                    Showing {displayStartItem}-{displayEndItem} of {totalItems} items
                </p>
            </div>
            <div className="pagination-right d-flex gap-2 align-items-center">
                <select
                    style={{ minWidth: "78px" }}
                    id="limit"
                    className="form-control form-select"
                    onChange={(e) => {
                        setLimit(Number(e.target.value))
                        setOffset(0)
                    }}
                >
                    <option value={25}>25</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                    <option value={300}>300</option>
                </select>
                <div className="d-flex align-items-center gap-3">
                    <Pagination
                        offset={offset}
                        setOffset={setOffset}
                        handlePageChange={handlePageChange}
                        pageCount={effectivePageCount}
                    />
                </div>
            </div>
        </div>
    </ >
}